import { FileCustom } from "../../tecnica/modules/consolidate_files/interfaces";
import { read } from "fs";
import * as XLSX from 'xlsx';
import { Workbook, Worksheet } from 'exceljs';
import { saveAs } from 'file-saver';
import fieldEarthMonitoring from "../../tecnica/config/field_earth_monitoring.json";
import { format } from 'date-fns';
import { excelSerialToTimeString } from "./times";

export const readExcelFile = async (files: FileCustom[],sheetName="Reporte",replaceChart=true, headerRow =5) => {

    let data: any[] = [];

    for (const fileCustom of files) {
        const file = fileCustom.file;
        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' });
            // const sheetName = workbook.SheetNames[0];

            if (!workbook.SheetNames.includes(sheetName)) {
                alert(`Debe seleccionar un archivo con la hoja "${sheetName}"`);
                return [];
            }

            const worksheet = workbook.Sheets[sheetName];

            const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
            range.s.r = headerRow-1; // Skip the first row
            worksheet['!ref'] = XLSX.utils.encode_range(range);

            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            const newData:any[] = []

            jsonData.forEach((line: any,i:number) => {

                let location = line['Pozo'] || line['Locación'] 

                if (!location || location === '') {
                    return;
                }

                const replacesChart = ['LB', 'LS', '-', 'A', 'B']

                if (replaceChart) {
                    replacesChart.forEach(chart => {
                        location = location?.toUpperCase().replace(chart, '');
                    })
                }

                location = location?.trim()
                const normalizedLine: any = {};
                Object.keys(line).forEach(key => {

                   const normalizedKey = key.replace(/[\r\n]/g, '').trim();
 
                    if( key.includes('Hora')){
                        line[key] = excelSerialToTimeString(line[key]);
                    }

                    if (key.includes('Fecha') || key.includes('Date')) {
                        if (typeof line[key] === 'number') {
                            // Convert Excel serial number to JavaScript Date
                            const date = new Date((line[key] - (25567 + 2)) * 86400 * 1000);
                            const fullDate = date.toISOString(); // Convert Date to ISO string
                            // line[key] = fullDate?.toString()?.split('T')[0];
                            const [year, month, day] = fullDate.split('T')[0].split('-'); // Split the date into parts
                            line[key] = `${day}-${month}-${year}`; // Rearrange to DD-MM-YYYY

                            // if (key.includes('Hora')) {
                            //     const prevalue = line[key];
                            //     const [hours, minutes] = date.toTimeString().split(':');
                            //     line[key] = `${hours}:${minutes}`;
                            //     // console.log({key, prevalue, value: line[key]});
                            // }
                        }
                    }

                    normalizedLine[normalizedKey] = line[key];
                });

                const fileName = workbook.Props?.Title || file.name;

                newData.push( { ...normalizedLine, Pozo: location, fileName, position:i })

                // return { ...normalizedLine, Pozo: location, fileName, position:i }

            })

            data = [...data, ...newData];
        } catch (error) {
            console.error('Error reading file:', error);
        }
    }

    return data;


};

export const readEchometerFile = async (files: FileCustom[]) => {

    let carts: any[] = [];


    for (const fileRaw of files) {
        const file = fileRaw.file;
        try {
            const text = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = reject;
                reader.readAsText(file);
            });
            const data: any = {}
            const lines = text.split('\n');
            const headers = lines[0].replaceAll('#', '').replace('\r', '').split('\t').map(header => header.trim());
            headers.forEach(header => {
                data[header] = [];
            })

            for (const line of lines.slice(1)) {
                try {
                    const values = line.split('\t').map(value => parseFloat(value.replace('#', '').trim()));
                    values.forEach((value, index) => {
                        data[headers[index]].push(value);
                    });
                } catch (error) {

                }

            }

            let fileNames = fileRaw?.fileName.replace('.txt', '');

            fileNames = fileNames.split('_')[0]

            fileNames = fileNames?.toLowerCase()?.replace('ls', '')?.replace('lb', '')?.trim();

            carts.push({ location: fileNames, ...data, type: 'echometer' });


        } catch (error) {
            console.error('Error reading text file:', error);
        }

    }

    return carts;
};


export const readSiamFile = async (files: FileCustom[]) => {
    let carts: any[] = [];

    for (const fileRaw of files) {
        const file = fileRaw.file;
        try {
            const text = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = reject;
                reader.readAsText(file);
            });
            const data: any = {}
            const lines = text.split('\n');
            let linesRemaining = lines.slice();
            const json_data: any[] = [];

            while (linesRemaining.length > 0) {
                try {
                    const numberOfPoint = parseInt(linesRemaining[0]);
                    const cardPoints = linesRemaining.slice(1, numberOfPoint + 1);
                    const surface_card_position = cardPoints.map(p => parseFloat(p.split(';')[0]?.replace(',', '.')));
                    const surface_card_load = cardPoints.map(p => parseFloat(p.split(';')[1]?.replace(',', '.')));
                    const well_name = linesRemaining[numberOfPoint + 10].replace('\r', '').replace(/"/g, '').split(' ')[1];

                    json_data.push({
                        "location": well_name,
                        "type": "siam",
                        "Surface Card Position": surface_card_position,
                        "Surface Card Load": surface_card_load
                    });

                    linesRemaining = linesRemaining.slice(numberOfPoint + 13);
                } catch (error) {
                    break;
                }
            }
            carts = [...carts, ...json_data];
        } catch (error) {

        }
    }

    return carts;
}

export function decimalToFraction(decimal: number): string {

    if (typeof decimal !== 'number') return decimal;

    if (decimal === 0) return '0';

    const tolerance = 1.0E-6;
    let h1 = 1, h2 = 0, k1 = 0, k2 = 1, b = decimal;
    do {
        const a = Math.floor(b);
        const aux = h1; h1 = a * h1 + h2; h2 = aux;
        const aux2 = k1; k1 = a * k1 + k2; k2 = aux2;
        b = 1 / (b - a);
    } while (Math.abs(decimal - h1 / k1) > decimal * tolerance);

    return `${h1}/${k1}`;
}


function numberToColumnLetter(num: number): string {
    let columnLetter = '';
    while (num > 0) {
        let remainder = (num - 1) % 26;
        columnLetter = String.fromCharCode(65 + remainder) + columnLetter;
        num = Math.floor((num - 1) / 26);
    }
    return columnLetter;
}

const addGroupToWorksheet = (worksheet: Worksheet, group: any, startRow: number, endRow: number, rowsFields: any, startLine: number) => {
    const startCol = numberToColumnLetter(startRow)
    const endCol = numberToColumnLetter(endRow)

    // group name

    const groupRange = `${startCol}${startLine}:${endCol}${startLine}`
    worksheet.mergeCells(groupRange);
    worksheet.getCell(`${startCol}${startLine}`).value = group?.name;
    worksheet.getCell(`${startCol}${startLine}`).alignment = { horizontal: 'center' };

    const sortAtt = group.attributes.sort((a: any, b: any) => a.order - b.order);

    // headers 
    for (let i = 0; i < sortAtt.length; i++) {
        rowsFields.push({
            name: group.attributes[i].name,
            id: group.attributes[i].id,
        })
        const att = group.attributes[i];
        const col = numberToColumnLetter(startRow + i);
        const cell = worksheet.getCell(`${col}${startLine + 1}`);
        cell.value = att.name;
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: att?.color || group?.color } };
        cell.font = { color: { argb: 'FFFFFFFF' } };

        if (group?.name !== "") {
            worksheet.getCell(`${col}${startLine}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: group?.color }
            };
            worksheet.getCell(`${col}${startLine}`).font = { color: { argb: '0D0D0D' } };
        }
    }
}

const fetchImageAsBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export async function generateExcelFile(data: any[], field: string) {


    const config = fieldEarthMonitoring;

    const file = 'reporte.xlsx';

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Reporte Campo');

    const base64 = await fetchImageAsBase64('/assets/images/nabe.png');

    const imageId = workbook.addImage({
        base64: base64,
        extension: 'png',
    });

    // Add the image to the worksheet
    worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 }, // Top-left corner
        ext: { width: 300, height: 140 }, // Width and height of the image
    });

    let startCol = 1;

    const startRow = 8;
    
    const maxCols = 86;

    // Fill all cells with white background
    for (let row = 1; row <= startRow; row++) {
        for (let col = 1; col <= maxCols; col++) {
            const cell = worksheet.getCell(row, col);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFFFF' }, // White color
            };
         }
    }

    // hard attributes

    const sortHardAtt = config?.hardAttributes?.sort((a, b) => a.order - b.order);

    for (const att of sortHardAtt) {
        const col = numberToColumnLetter(startCol)
        const cell = worksheet.getCell(`${col}$${startRow + 1}`);
        cell.value = att?.name;
        cell.alignment = { horizontal: 'center' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: att?.color } };
        cell.font = { color: { argb: 'FFFFFFFF' } };
        startCol = startCol + 1;
    }

    const attGroupSorted = config?.attributesGroups.sort((a, b) => a.order - b.order);

    const rowsFields: any[] = []


    for (const attg of attGroupSorted) {
        addGroupToWorksheet(worksheet, attg, startCol, startCol + attg.attributes.length - 1, rowsFields, startRow);

        startCol = startCol + attg.attributes.length;
    }

    const dataRows: any[] = []

    let fileDate = new Date();

    for (const act of data) {
        let startRowForData = 0;

        const col = numberToColumnLetter(startRowForData)

        let fecha = act?.['FECHA']
        try {
            fecha = new Date(fecha)
            fileDate = fecha;
        } catch (error) {
            console.log({ error });            
        }
        

        const row: any = {
            "FECHA": fecha,
            "Pozo": `${act?.['Pozo']}`,
        }

        for (const field of rowsFields) {
            if (typeof (field?.name) === "string") {
                const value = act?.[field?.name]
                row[field.name] = value;
            }
        }

        dataRows.push(row)
    }

    dataRows.forEach((row, index) => {
        const rowIndex = index + startRow + 2;
        for (const field of Object.keys(row)) {
            const col = numberToColumnLetter(Object.keys(row).indexOf(field) + 1)
            worksheet.getCell(`${col}${rowIndex}`).value = row[field];
        }
    })


    // Add borders to all cells in the worksheet
    worksheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number>=startRow) {
        row.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });}
    });

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Save the file
    // const currentDate = new Date();
    const day = String(fileDate.getDate()).padStart(2, '0');
    const month = String(fileDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = fileDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${field}-${formattedDate}-report.xlsx`);
}

export const addImageBeforeHeader = async () => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    // Add some headers
    worksheet.columns = [
        { header: 'ID', key: 'id', width: 10 },
        { header: 'Name', key: 'name', width: 30 },
        { header: 'Age', key: 'age', width: 10 },
    ];

    const base64 = await fetchImageAsBase64('/assets/images/nabe.png');

    // Add some data
    worksheet.addRow({ id: 1, name: 'John Doe', age: 30 });
    worksheet.addRow({ id: 2, name: 'Jane Smith', age: 25 });

    // Load the image
    const imageId = workbook.addImage({
        base64: base64,
        extension: 'png',
    });

    // Add the image to the worksheet
    worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 }, // Top-left corner
        ext: { width: 200, height: 100 }, // Width and height of the image
    });

    // Adjust the rows to make space for the image
    worksheet.getRow(1).height = 100; // Adjust the height of the first row

    // Generate buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Save the file
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'example_with_image.xlsx');
};

export const processValue = (value: number | string): number | string => {
    if (typeof value === 'string') {
        return value;
    } else if (typeof value === 'number') {
        if (value > 1000) {
            return value / 1000;
        } else if (value > 100) {
            return value / 100;
        } else {
            return value;
        }
    }
    return value;
};

export const formatDate = (dateString:string, outputFormat='dd-MMM HH:mm:ss' ) => {
    const date = new Date(dateString);
    return format(date, outputFormat);
  };

export const convertArrayOfObjectsToCSV = (data: any[]) => {
    const csvRows = [];
  
    // Get the headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));
  
    // Loop over the rows
    for (const row of data) {
      const values = headers.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
  
    return csvRows.join('\n');
  };